// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Billing.css — 구독 결제 (SubscribeModal, BillingSuccess/Fail, 구독 상태 카드) */

/* ───────────────── 구독 체크아웃 모달 (skill-modal 베이스 위에 확장) ───────────────── */
.billing-modal {
  max-width: 440px;
  width: 100%;
}

.billing-modal__body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.billing-modal__cycle {
  display: flex;
  gap: 6px;
  padding: 4px;
  background: var(--gray-100);
  border-radius: var(--radius-full);
}

.billing-modal__cycle-btn {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: var(--radius-full);
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: var(--transition-fast);
}

.billing-modal__cycle-btn.is-active {
  background: var(--surface);
  color: var(--text-primary);
  box-shadow: var(--shadow-sm);
}

.billing-modal__cycle-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.billing-modal__cycle-badge {
  font-size: 11px;
  font-weight: 700;
  color: var(--success-dark);
  background: var(--success-light);
  padding: 2px 6px;
  border-radius: var(--radius-sm);
}

.billing-modal__summary {
  padding: 18px;
  background: var(--fg-bg-litepp, var(--primary-50));
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
}

.billing-modal__summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.billing-modal__summary-label {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
}

.billing-modal__summary-cycle {
  font-size: 13px;
  color: var(--text-secondary);
}

.billing-modal__price {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.billing-modal__price-amount {
  font-size: 28px;
  font-weight: 800;
  color: var(--text-primary);
}

.billing-modal__price-suffix {
  font-size: 14px;
  color: var(--text-secondary);
}

.billing-modal__price-note {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--success-dark);
}

.billing-modal__features {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.billing-modal__feature {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--text-secondary);
}

.billing-modal__feature svg {
  color: var(--primary-600);
  flex-shrink: 0;
}

.billing-modal__notice {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
  color: var(--text-tertiary);
  padding: 12px;
  background: var(--gray-50);
  border-radius: var(--radius-md);
}

/* 결제수단 선택 푸터 — 결제수단 버튼을 세로로 쌓는다(카드 / 카카오페이 / 취소). */
.billing-modal__foot {
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

/* .skill-modal__btn(height:36px) 보다 우선하도록 2-클래스 선택자 사용. */
.billing-modal__foot .billing-modal__pay-btn {
  width: 100%;
  height: 46px;
  font-size: 15px;
  font-weight: 700;
}

/* 카카오페이 브랜드 — 노란 배경(#FEE500) + 검정 텍스트(#191919). */
.billing-modal__foot .billing-modal__pay-btn--kakao {
  background: #fee500;
  color: #191919;
  border-color: #fee500;
}

.billing-modal__foot .billing-modal__pay-btn--kakao:hover:not(:disabled) {
  background: #f4d800;
}

.billing-modal__foot .billing-modal__pay-btn--kakao svg {
  color: #191919;
}

.billing-modal__foot .billing-modal__cancel-btn {
  width: 100%;
  height: 40px;
}

/* ───────────────── 결제 결과 페이지 (success / fail) ───────────────── */
.billing-result {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--background);
}

.billing-result__card {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 40px 28px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-lg);
}

.billing-result__icon--ok {
  color: var(--success);
}

.billing-result__icon--err {
  color: var(--error);
}

.billing-result__spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--gray-200);
  border-top-color: var(--primary-600);
  border-radius: var(--radius-full);
  animation: billing-spin 0.8s linear infinite;
}

@keyframes billing-spin {
  to { transform: rotate(360deg); }
}

.billing-result__title {
  margin: 4px 0 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
}

.billing-result__message {
  margin: 0;
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
}

.billing-result__code {
  margin: 0;
  font-size: 12px;
  color: var(--text-tertiary);
}

.billing-result__actions {
  margin-top: 12px;
  display: flex;
  gap: 8px;
}

/* ───────────────── 구독 상태 카드 (SettingsBilling) ───────────────── */
.settings-subscription {
  padding: 0;
}

.settings-subscription__main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}

.settings-subscription__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.settings-subscription__badge {
  align-self: flex-start;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: var(--radius-full);
  margin-bottom: 4px;
}

.settings-subscription__badge--active {
  color: var(--success-dark);
  background: var(--success-light);
}

.settings-subscription__badge--canceled {
  color: var(--warning-text);
  background: var(--warning-light);
}

.settings-subscription__plan {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}

.settings-subscription__meta {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
}

.settings-subscription__cancel {
  flex-shrink: 0;
  padding: 8px 16px;
  border: 1px solid var(--border);
  background: var(--surface);
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: var(--transition-fast);
}

.settings-subscription__cancel:hover {
  border-color: var(--error);
  color: var(--error);
}

/* 현재 구독 중인 플랜 카드 강조 */
.settings-plan-card--current {
  border-color: var(--primary-400);
  box-shadow: var(--focus-ring);
}

/* "현재 등급" CTA — 클릭 불가, 차분한 표기 */
.settings-plan-card__cta--current {
  background: var(--gray-100);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  cursor: default;
}

.settings-plan-card__cta--current:hover {
  background: var(--gray-100);
}
`, "",{"version":3,"sources":["webpack://./src/css/Billing.css"],"names":[],"mappings":"AAAA,wEAAwE;;AAExE,2EAA2E;AAC3E;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;AACV;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oCAAoC;EACpC,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA,mEAAmE;AACnE;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Billing.css — 구독 결제 (SubscribeModal, BillingSuccess/Fail, 구독 상태 카드) */\n\n/* ───────────────── 구독 체크아웃 모달 (skill-modal 베이스 위에 확장) ───────────────── */\n.billing-modal {\n  max-width: 440px;\n  width: 100%;\n}\n\n.billing-modal__body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.billing-modal__cycle {\n  display: flex;\n  gap: 6px;\n  padding: 4px;\n  background: var(--gray-100);\n  border-radius: var(--radius-full);\n}\n\n.billing-modal__cycle-btn {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-full);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.billing-modal__cycle-btn.is-active {\n  background: var(--surface);\n  color: var(--text-primary);\n  box-shadow: var(--shadow-sm);\n}\n\n.billing-modal__cycle-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.billing-modal__cycle-badge {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--success-dark);\n  background: var(--success-light);\n  padding: 2px 6px;\n  border-radius: var(--radius-sm);\n}\n\n.billing-modal__summary {\n  padding: 18px;\n  background: var(--fg-bg-litepp, var(--primary-50));\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n}\n\n.billing-modal__summary-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.billing-modal__summary-label {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.billing-modal__summary-cycle {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.billing-modal__price {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.billing-modal__price-amount {\n  font-size: 28px;\n  font-weight: 800;\n  color: var(--text-primary);\n}\n\n.billing-modal__price-suffix {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.billing-modal__price-note {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: var(--success-dark);\n}\n\n.billing-modal__features {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.billing-modal__feature {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.billing-modal__feature svg {\n  color: var(--primary-600);\n  flex-shrink: 0;\n}\n\n.billing-modal__notice {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.6;\n  color: var(--text-tertiary);\n  padding: 12px;\n  background: var(--gray-50);\n  border-radius: var(--radius-md);\n}\n\n/* 결제수단 선택 푸터 — 결제수단 버튼을 세로로 쌓는다(카드 / 카카오페이 / 취소). */\n.billing-modal__foot {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n}\n\n/* .skill-modal__btn(height:36px) 보다 우선하도록 2-클래스 선택자 사용. */\n.billing-modal__foot .billing-modal__pay-btn {\n  width: 100%;\n  height: 46px;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n/* 카카오페이 브랜드 — 노란 배경(#FEE500) + 검정 텍스트(#191919). */\n.billing-modal__foot .billing-modal__pay-btn--kakao {\n  background: #fee500;\n  color: #191919;\n  border-color: #fee500;\n}\n\n.billing-modal__foot .billing-modal__pay-btn--kakao:hover:not(:disabled) {\n  background: #f4d800;\n}\n\n.billing-modal__foot .billing-modal__pay-btn--kakao svg {\n  color: #191919;\n}\n\n.billing-modal__foot .billing-modal__cancel-btn {\n  width: 100%;\n  height: 40px;\n}\n\n/* ───────────────── 결제 결과 페이지 (success / fail) ───────────────── */\n.billing-result {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: var(--background);\n}\n\n.billing-result__card {\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n  padding: 40px 28px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-2xl);\n  box-shadow: var(--shadow-lg);\n}\n\n.billing-result__icon--ok {\n  color: var(--success);\n}\n\n.billing-result__icon--err {\n  color: var(--error);\n}\n\n.billing-result__spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--gray-200);\n  border-top-color: var(--primary-600);\n  border-radius: var(--radius-full);\n  animation: billing-spin 0.8s linear infinite;\n}\n\n@keyframes billing-spin {\n  to { transform: rotate(360deg); }\n}\n\n.billing-result__title {\n  margin: 4px 0 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.billing-result__message {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n.billing-result__code {\n  margin: 0;\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n\n.billing-result__actions {\n  margin-top: 12px;\n  display: flex;\n  gap: 8px;\n}\n\n/* ───────────────── 구독 상태 카드 (SettingsBilling) ───────────────── */\n.settings-subscription {\n  padding: 0;\n}\n\n.settings-subscription__main {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n}\n\n.settings-subscription__info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.settings-subscription__badge {\n  align-self: flex-start;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n  margin-bottom: 4px;\n}\n\n.settings-subscription__badge--active {\n  color: var(--success-dark);\n  background: var(--success-light);\n}\n\n.settings-subscription__badge--canceled {\n  color: var(--warning-text);\n  background: var(--warning-light);\n}\n\n.settings-subscription__plan {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.settings-subscription__meta {\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.settings-subscription__cancel {\n  flex-shrink: 0;\n  padding: 8px 16px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.settings-subscription__cancel:hover {\n  border-color: var(--error);\n  color: var(--error);\n}\n\n/* 현재 구독 중인 플랜 카드 강조 */\n.settings-plan-card--current {\n  border-color: var(--primary-400);\n  box-shadow: var(--focus-ring);\n}\n\n/* \"현재 등급\" CTA — 클릭 불가, 차분한 표기 */\n.settings-plan-card__cta--current {\n  background: var(--gray-100);\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n  cursor: default;\n}\n\n.settings-plan-card__cta--current:hover {\n  background: var(--gray-100);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
